import { useState, FormEvent, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { Container, Dialog, DialogContentText, Stack } from "@mui/material";

import conf from "../../conf";
import Spinner from "../utils/Spinner";
import SectionHeader from "../utils/SectionHeader";
import ProviderSelect from "./ProviderSelect";
import { IdpConfig, useConfgOrganizationAddIdp } from "../../hooks/confg/base";

const ProviderAddView = (props: any) => {
  const { open, onClose } = props;

  const [locked, setLocked] = useState(false);
  const [idp, setIdp] = useState<IdpConfig[]>([]);

  const add = useConfgOrganizationAddIdp();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    add.mutate(idp);
  };

  useEffect(() => {
    if (add.isSuccess) {
      onClose();
      setIdp([]);
    }
  }, [add.isSuccess]);

  return (
    <Dialog maxWidth="md" fullWidth open={open} onClose={onClose}>
      <Container component="main" sx={conf.STYLE.DIALOG}>
        <SectionHeader
          key="idp-add-header"
          title="Add provider"
          icon={<AddIcon />}
          buttons={[
            <Button
              key={"idp-add-close"}
              size="small"
              color="inherit"
              onClick={onClose}
            >
              <CloseIcon />
            </Button>,
          ]}
        />

        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DialogContentText variant="caption">
                To add a new identity provider for this organization please
                select IDP(s), then submit. Credentials must be provided for the
                identity provider. Changes will not take effect until submitted
                & confirmed. Note: Will ask for confirmation.
              </DialogContentText>

              <ProviderSelect idp={idp} setIdp={setIdp} disabled={locked} />
            </Grid>
          </Grid>

          <Stack direction="row" justifyContent="flex-end" alignItems="center">
            <Button
              variant={locked ? "outlined" : "contained"}
              onClick={() => setLocked(!locked)}
              sx={{ mt: 3, mb: 2, mr: 2 }}
            >
              {locked ? "Cancel" : "Save"}
            </Button>

            <Button
              type="submit"
              variant="contained"
              disabled={!locked}
              sx={{ mt: 3, mb: 2 }}
            >
              {add.isPending ? <Spinner sx={{ mx: 2.5 }} /> : "Submit"}
            </Button>
          </Stack>
        </Box>
      </Container>
    </Dialog>
  );
};

const ProviderAdd = ({ disabled = false }: { disabled?: boolean }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        size="small"
        color="secondary"
        variant="contained"
        disabled={disabled}
        onClick={handleOpen}
        startIcon={<AddIcon />}
      >
        Add
      </Button>

      <ProviderAddView open={open} onClose={handleClose} />
    </div>
  );
};

export default ProviderAdd;
